import SmartCardQuery from 'Query/SmartCard.query';
import { showNotification } from 'Store/Notification/Notification.action';
import { fetchMutation, getErrorMessage } from 'Util/Request';

import { updateSmartCard } from './SmartCardForm.action';

/**
 * SmartCardForm Dispatcher
 * @class SmartCardFromDispatcher
 * @extends QueryDispatcher
 * @namespace Store/SmartCardForm/Dispatcher
 */
export class SmartCardFormDispatcher {
  prepareRequest(options, dispatch) {
    const mutation = SmartCardQuery.getSendSmartCardMutation(options);

    dispatch(
      updateSmartCard({
        isLoading: true,
        isSubmitted: false,
      })
    );

    return fetchMutation(mutation).then(
      /** @namespace Store/SmartCardForm/Dispatcher/fetchMutationThen */
      (data) => {
        dispatch(showNotification('success', data.smartCardInput.message));
        dispatch(
          updateSmartCard({
            isLoading: false,
            isSubmitted: true,
          })
        );
      },
      /** @namespace Store/SmartCard/Dispatcher/fetchMutationError */
      (error) => {
        dispatch(showNotification('error', getErrorMessage(error)));
        dispatch(
          updateSmartCard({
            isLoading: false,
            isSubmitted: false,
          })
        );
      }
    );
  }
}

export default new SmartCardFormDispatcher();
